import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { withUrlValidation } from '../components/withUrlValidation';
import { Timestamp, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { addSentMessagesFieldToUser, findValidUser, updateUserInTimeBasedCollection, getAllUsersInTimeWindow, saveMessageToCollectionSentMessages, getUserFromTimeBasedCollection } from '../utils/firebaseUtils';
import { getAvatarRegistrationTime, saveExperienceTimeData, incrementMessageSentUsers, incrementMessageSendCount } from '../utils/funnelDataUtils';
import BluePopup from '../components/BluePopup';
import { useNavigate } from 'react-router-dom';
import Bookmark from '../components/Bookmark';
import backgroundImage from '../assets/images/13MessageBG.png';
import titleImage from '../assets/images/13message-title.png';
import chooseImage from '../assets/images/13message-choose.png';
import coinContainerImage from '../assets/images/13message-coin-container.png';
import refreshImage from '../assets/images/13message-refresh.png';
import scrollbarImage from '../assets/images/13message-scrollbar.png';
import scrollHeaderImage from '../assets/images/13message-scollHeader.png';
import questionImage from '../assets/images/02register-question.png';
import tipPopupImage from '../assets/images/13message-tip-pop.png';
import messageContainerImage from '../assets/images/13message-container.png';
import messageContainerSelectedImage from '../assets/images/13message-container-selected.png';
import chosenOkImage from '../assets/images/13message-choosen-ok.png';
import backButtonImage from '../assets/images/13message-back-btn.png';
import chooseTextImage from '../assets/images/13message-choose-txt.png';
import sendMessageContainerImage from '../assets/images/13message-sendMSGcontainer.png';
import cancelButtonImage from '../assets/images/13message-no.png';
import okButtonImage from '../assets/images/13message-yes.png';
import anotherImage from '../assets/images/13message-another.png';
import secondPopupButtonImage from '../assets/images/13message-scd-pop-btn.png';
import nextButtonImage from '../assets/images/13message-next.png';
import loadingImage from '../assets/images/loading.png';
import receivedAvatarImage from '../assets/images/13message-recievedAvatar.png';
import { DUMMY_NICKNAMES, NICKNAME_BACKGROUND_MAP } from '../utils/dummyData';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: url(${backgroundImage}) center/cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  font-family: 'MapoDPP', sans-serif;
  color: white;
  overflow: hidden;
  box-sizing: border-box;
`;

const TitleImage = styled.img`
  width: 80%;
  height: auto;
  margin-top: 10%;
  margin-bottom: 2rem;
`;

const ChooseImage = styled.img`
  width: 80%;
  max-width: 350px;
  height: auto;
  margin-bottom: 2rem;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 90%;
  margin-bottom: 0.5rem;
`;

const CoinContainer = styled.div`
  position: relative;
  width: 45%;
  max-width: 200px;
`;

const CoinImage = styled.img`
  width: 100%;
  height: auto;
`;

const CoinText = styled.div`
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1rem;
  font-family: 'MapoDPP', sans-serif;
  color: white;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.8);
  text-align: center;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const CoinNumber = styled.span`
  color: #FFD700;
`;

const TipButton = styled.div`
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-50%) scale(1.1);
  }
`;



const TipButtonImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const TipPopup = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.5);
  display: ${props => props.isVisible ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 1000;
  cursor: pointer;
`;

const TipPopupImage = styled.img`
  width: 80%;
  max-width: 400px;
  height: auto;
  cursor: pointer;
`;

const RefreshButton = styled.div`
  width: 20%;
  margin-right: 4dvw;
  cursor: pointer;
  transition: transform 0.2s ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;

const RefreshImage = styled.img`
  width: 100%;
  height: auto;
`;

const ScrollContainer = styled.div`
  position: relative;
  width: 95%;
  height: calc(100dvh - 35dvh);
  min-height: 40dvh;
  max-height: 60dvh;
  display: flex;
  margin-left: 5%;
  flex: 1;
  overflow: hidden;
`;

const ScrollContent = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.7rem;
  align-content: start;
  height: 100%;
  
  /* 기본 스크롤바 숨기기 */
  &::-webkit-scrollbar {
    width: 0px;
    display: none;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  
  /* Firefox에서 스크롤바 숨기기 */
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  /* 모바일에서 터치 스크롤 최적화 */
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
`;

const ScrollBar = styled.div`
  position: relative;
  width: 8dvw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 5dvw;
  margin-bottom: 5dvw;
`;

const ScrollHeader = styled.div`
  width: 5dvw;
  height: 5dvw;
  flex-shrink: 0;
  position: absolute;
  top: 4dvw;
  right: 1.5dvw;
  z-index: 20;
`;

const ScrollHeaderImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ScrollThumb = styled.div<{ top: number; height: number }>`
  position: absolute;
  right: 0;
  width: 100%;
  height: ${props => props.height}px;
  top: ${props => props.top}px;
  cursor: grab;
  transition: top 0.1s ease;
  z-index: 10;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    cursor: grabbing;
  }
`;

const ScrollThumbImage = styled.img`
  width: 100%;
  object-fit: cover;
`;

const ScrollTrack = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  cursor: pointer;
  background: url(${scrollbarImage}) center/cover no-repeat;
  border-radius: 10px;
`;

const ChosenOkButton = styled.button<{ isDisabled?: boolean }>`
  width: 80%;
  max-width: 300px;
  height: auto;
  margin-top: 2rem;
  margin-bottom: 2rem;
  background: none;
  border: none;
  cursor: ${props => props.isDisabled ? 'not-allowed' : 'pointer'};
  transition: transform 0.2s ease;
  opacity: ${props => props.isDisabled ? 0.5 : 1};
  
  &:hover {
    transform: ${props => props.isDisabled ? 'none' : 'scale(1.05)'};
  }
  
  &:active {
    transform: ${props => props.isDisabled ? 'none' : 'scale(0.95)'};
  }
`;

const ChosenOkImage = styled.img`
  width: 100%;
  height: auto;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
`;

const Message = styled.p`
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

interface UserData {
  id: string;
  nickname: string;
  background: string;
  createdAt: Date | Timestamp;
}

interface FirebaseUserData {
  age: string;
  avatarNumber: string;
  background: string;
  coinCount: number;
  createdAt: Timestamp;
  nickname: string;
  zoneClearStatus: {
    zone1: string;
    zone2: string;
    zone3: string;
    zone4: string;
    zone5: string;
    zone6: string;
  };
  receivedMessages?: Array<{
    message: string;
    senderNickname: string;
    receivedAt: Timestamp;
  }>;
  sentMessages?: Array<{
    message: string;
    receiverNickname: string;
    sentAt: Timestamp;
  }>;
}

const MessageContainer = styled.div<{ aspectRatio?: number; isSelected?: boolean; isDisabled?: boolean; isFontLoaded?: boolean }>`
  position: relative;
  width: 100%;
  height: ${props => props.aspectRatio ? `${43 / props.aspectRatio}vw` : '5dvw'};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
  opacity: ${props => props.isFontLoaded ? 1 : 0};
  transition: opacity 0.3s ease;
  
  ${props => props.isSelected && `
    filter: brightness(1.2) contrast(1.1);
  `}
  
  ${props => props.isDisabled && !props.isSelected && `
    filter: grayscale(0.8) brightness(0.7);
    opacity: 0.6;
  `}
`;

const MessageContainerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const MessageContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
`;

const NicknameText = styled.div<{ aspectRatio?: number; textLength?: number; isSelected?: boolean }>`
  position: absolute;
  top: 39%;
  left: 8%;
  transform: translate(0, -50%);
  font-size: ${props => {
    if (!props.aspectRatio) return '1rem';
    const baseSize = 43 / props.aspectRatio * 0.15;
    return props.textLength && props.textLength > 12 
      ? `${baseSize * 0.8}vw` 
      : `${baseSize}vw`;
  }};
  color: ${props => props.isSelected ? '#204C64' : 'white'};
  text-align: left;
  font-family: 'MapoDPP', sans-serif;
  white-space: nowrap;
  transition: color 0.3s ease;
`;

const BackgroundText = styled.div<{ aspectRatio?: number; textLength?: number; isSelected?: boolean }>`
  position: absolute;
  top: 71%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: ${props => {
    if (!props.aspectRatio) return '1rem';
    const baseSize = 43 / props.aspectRatio * 0.15;
    return props.textLength && props.textLength > 7 
      ? `${baseSize * 0.8}vw` 
      : `${baseSize}vw`;
  }};
  color: ${props => props.isSelected ? '#204C64' : 'white'};
  text-align: center;
  font-family: 'MapoDPP', sans-serif;
  white-space: nowrap;
  transition: color 0.3s ease;
`;

const BackButton = styled.button`
  position: absolute;
  top: 2%;
  left: 4%;
  width: 3dvw;
  height: auto;
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;
  z-index: 100;
  
  &:hover {
    transform: scale(1.1);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const BackButtonImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const ChooseTextImage = styled.img`
  width: 45%;
  margin-top: 1dvw;
  height: auto;
  margin-bottom: 2rem;
`;

const MessageSendContainer = styled.div<{ aspectRatio?: number; isFontLoaded?: boolean }>`
  position: relative;
  width: 100%;
  height: ${props => props.aspectRatio ? `${82 / props.aspectRatio}vw` : '5dvw'};
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 0.1dvw;
  transition: all 0.3s ease;
  opacity: ${props => props.isFontLoaded ? 1 : 0};
  
  &:hover {
    transform: scale(1.02);
  }
`;

const MessageSendContainerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const MessageSendContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 5%;
`;

const MessageText = styled.div<{ aspectRatio?: number; textLength?: number }>`
  font-size: ${props => {
    if (!props.aspectRatio) return '1.2rem';
    const baseSize = 43 / props.aspectRatio * 0.47;
    return props.textLength && props.textLength > 50 
      ? `${baseSize * 0.9}vw` 
      : `${baseSize}vw`;
  }};
  color: white;
  text-align: center;
  font-family: 'HeirofLightRegular', 'MapoDPP', sans-serif;
  line-height: 1.4;
  word-break: keep-all;
  text-shadow: 0 0 25px #3884FF;
`;

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const PopupButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;
  width: 42dvw;
  height: auto;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const PopupButtonImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const SecondPopupButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;
  width: 85dvw;
  height: auto;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const SecondPopupButtonImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const NextButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease;
  width: 82dvw;
  height: auto;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const NextButtonImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const PopupConfirmText = styled.div`
  color: white;
  font-family: 'MapoDPP', sans-serif;
  font-size: 4.5dvw;
  text-align: center;
  text-shadow: 0 2px 4px rgba(0,0,0,0.7);
`;

const AvatarContainer = styled.div`
  position: relative;
  width: 72dvw;
  height: 20dvw;
  margin-bottom: 1dvw;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AvatarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const AvatarNickname = styled.div`
  position: absolute;
  top: 67%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-family: 'HeirofLightRegular', sans-serif;
  font-size: 4.2dvw;
  font-weight: 600;
  text-align: center;
  width: 60dvw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MessageSend: React.FC = () => {
  const [isValid, setIsValid] = useState<boolean | null>(null);
  const [coinCount, setCoinCount] = useState<number>(0);
  const [users, setUsers] = useState<UserData[]>([]);
  const [scrollTop, setScrollTop] = useState<number>(0);
  const [scrollHeight, setScrollHeight] = useState<number>(0);
  const [clientHeight, setClientHeight] = useState<number>(0);
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [dragStartY, setDragStartY] = useState<number>(0);
  const [dragStartScrollTop, setDragStartScrollTop] = useState<number>(0);
  const [showTipPopup, setShowTipPopup] = useState<boolean>(false);
  const [imageAspectRatio, setImageAspectRatio] = useState<number>(3); // 기본값
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [selectedUser, setSelectedUser] = useState<UserData | null>(null);
  const [isMessageSendMode, setIsMessageSendMode] = useState<boolean>(false);
  const [sendMessageAspectRatio, setSendMessageAspectRatio] = useState<number>(3);
  const [showMessageConfirmPopup, setShowMessageConfirmPopup] = useState<boolean>(false);
  const [selectedMessageIndex, setSelectedMessageIndex] = useState<number | null>(null);
  const [isPopupClosing, setIsPopupClosing] = useState<boolean>(false);
  const [currentUserNickname, setCurrentUserNickname] = useState<string>('');
  const [showPopupElements, setShowPopupElements] = useState<boolean>(false);
  const [showSecondPopup, setShowSecondPopup] = useState<boolean>(false);
  const [showThirdPopup, setShowThirdPopup] = useState<boolean>(false);
  const [showThirdPopupElements, setShowThirdPopupElements] = useState<boolean>(false);
  const [showSecondPopupElements, setShowSecondPopupElements] = useState<boolean>(false);
  const [showCoinInsufficientPopup, setShowCoinInsufficientPopup] = useState<boolean>(false);
  const [showCoinInsufficientElements, setShowCoinInsufficientElements] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
  const [isFontLoaded, setIsFontLoaded] = useState<boolean>(false);
  const [isSendingMessage, setIsSendingMessage] = useState<boolean>(false);
  const scrollContentRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  // 미리 작성된 메시지 목록
  const predefinedMessages: string[] = [
    '"당신의 선택에 흥미로워합니다."',
    '"당신의 선택에 재미있어합니다."',
    '"당신의 호쾌한 발언에\n고개를 끄덕입니다."',
    '"당신의 선택에 고개를 끄덕입니다."',
    '"당신의 계획에 눈을 반짝입니다."',
    '"당신의 계책을 궁금해합니다."',
    '"당신의 근성에 감탄합니다."',
    '"당신의 침착함에 감탄합니다."',
    '"알고 있었다는 듯\n흐뭇한 미소를 짓습니다."',
    '"당신의 준비성에 감탄합니다."',
    '"즐거워합니다."',
    '"당신의 혼잣말을 좋아합니다."',
    '"눈을 반짝입니다."',
    '"당신의 선택을 기대합니다."',
    '"감동하며 눈물을 글썽입니다."',
    '"아쉬워합니다."',
    '"기뻐합니다."',
    '"당신의 준비성을 칭찬합니다."',
    '"그럴줄 알았다며 감탄합니다."',
  ];

  // 메시지를 랜덤하게 섞는 함수
  const shuffleMessages = (messages: string[]): string[] => {
    const shuffled = [...messages];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  // 폰트 로딩 완료 감지 함수
  const checkFontLoaded = async () => {
    try {
      // MapoDPP 폰트가 로드되었는지 확인
      await document.fonts.load('1rem "MapoDPP"');
      await document.fonts.load('1rem "HeirofLightRegular"');
      
      // 폰트 로딩 완료 후 약간의 지연을 두어 안정성 확보
      setTimeout(() => {
        setIsFontLoaded(true);
      }, 100);
    } catch (error) {
      console.error('폰트 로딩 확인 오류:', error);
      // 오류 발생 시에도 UI를 표시하도록 함
      setIsFontLoaded(true);
    }
  };

  // 랜덤하게 섞인 메시지 배열
  const [shuffledMessages, setShuffledMessages] = useState<string[]>([]);

  // 이미지 비율 계산
  const calculateImageAspectRatio = () => {
    const img = new Image();
    img.onload = () => {
      const ratio = img.width / img.height;
      setImageAspectRatio(ratio);
    };
    img.src = messageContainerImage;
  };

  // 메시지 전송용 이미지 비율 계산
  const calculateSendMessageAspectRatio = () => {
    const img = new Image();
    img.onload = () => {
      const ratio = img.width / img.height;
      setSendMessageAspectRatio(ratio);
    };
    img.src = sendMessageContainerImage;
  };

  // 파이어베이스에서 현재 사용자 정보 가져오기
  const fetchCurrentUserFromFirebase = async (nickname: string, avatarNumber: string) => {
    try {
      
      const userData = await findValidUser(nickname, avatarNumber);
      
      if (userData) {
        
        // createdAt을 Date 객체로 변환
        let createdAt: Date;
        if (userData.createdAt && typeof userData.createdAt.toDate === 'function') {
          createdAt = userData.createdAt.toDate();
        } else {
          createdAt = new Date();
        }
        
        // 로컬 스토리지 업데이트
        const updatedUserData = {
          nickname: userData.nickname,
          avatarNumber: userData.avatarNumber,
          age: userData.age,
          background: userData.background,
          coinCount: userData.coinCount,
          zoneClearStatus: userData.zoneClearStatus,
          createdAt: createdAt.toISOString()
        };
        
        localStorage.setItem('currentUser', JSON.stringify(updatedUserData));
        
        return updatedUserData;
      } else {
        return null;
      }
    } catch (error) {
      console.error('파이어베이스에서 사용자 정보 가져오기 오류:', error);
      return null;
    }
  };

  // 파이어베이스에서 2시간 이내 생성된 유저들 가져오기 (자기 자신 제외)
  const fetchRecentUsers = async () => {
    try {
      // 현재 로그인한 사용자 정보 가져오기
      const currentUser = localStorage.getItem('currentUser');
      let currentUserData: { nickname: string; avatarNumber: string } | null = null;
      
      if (currentUser) {
        try {
          currentUserData = JSON.parse(currentUser);
        } catch (error) {
          console.error('현재 사용자 데이터 파싱 오류:', error);
        }
      }
      
      // 새로운 시간 기반 컬렉션 구조를 사용하여 2시간 이내 생성된 사용자들 가져오기
      const allUsers = await getAllUsersInTimeWindow(2); // 2시간 이내
      
      // 자기 자신을 제외하고 createdAt 시간을 확인하여 필터링
      const filteredUsers = allUsers
        .filter(user => {
          // CollectionSentMessages 문서 제외 (유저 데이터가 아님)
          if (user.id && user.id.includes('CollectionSentMessages')) {
            return false;
          }
          
          // 자기 자신 제외
          if (currentUserData && 
              user.nickname === currentUserData.nickname && 
              user.avatarNumber === currentUserData.avatarNumber) {
            return false;
          }
          
          // createdAt 시간 확인
          if (user.createdAt) {
            const createdAt = user.createdAt.toDate ? user.createdAt.toDate() : new Date(user.createdAt);
            const now = new Date();
            const hoursDiff = (now.getTime() - createdAt.getTime()) / (1000 * 60 * 60);
            return hoursDiff <= 2;
          }
          
          return false;
        })
        .map(user => ({
          id: user.id,
          nickname: user.nickname || '익명',
          background: user.background || '없음',
          createdAt: user.createdAt?.toDate ? user.createdAt.toDate() : new Date(user.createdAt)
        }));

      // 더미 유저 판단 함수 (닉네임과 배경이 모두 일치하는 경우)
      const isDummyUser = (nickname: string, background: string) => {
        return NICKNAME_BACKGROUND_MAP[nickname as keyof typeof NICKNAME_BACKGROUND_MAP] === background;
      };

      // 실제 유저와 더미 유저 분리
      const realUsers = filteredUsers.filter(user => !isDummyUser(user.nickname, user.background));
      const dummyUsers = filteredUsers.filter(user => isDummyUser(user.nickname, user.background));

      // 중복 제거 함수 (닉네임과 배경이 같은 사용자 중 가장 최신 것만 유지)
      const removeDuplicates = (users: UserData[]) => {
        const uniqueUsers = new Map<string, UserData>();
        
        users.forEach(user => {
          const key = `${user.nickname}_${user.background}`;
          const existingUser = uniqueUsers.get(key);
          
          if (!existingUser) {
            uniqueUsers.set(key, user);
          } else {
            // createdAt 시간 비교
            const userTime = user.createdAt instanceof Date ? user.createdAt.getTime() : user.createdAt.toDate().getTime();
            const existingTime = existingUser.createdAt instanceof Date ? existingUser.createdAt.getTime() : existingUser.createdAt.toDate().getTime();
            
            if (userTime > existingTime) {
              uniqueUsers.set(key, user);
            }
          }
        });
        
        return Array.from(uniqueUsers.values());
      };

      // 중복 제거 적용
      const uniqueRealUsers = removeDuplicates(realUsers);
      const uniqueDummyUsers = removeDuplicates(dummyUsers);

      // 실제 유저가 있으면 실제 유저만 표시, 없으면 더미 유저 표시
      const usersToShow = uniqueRealUsers.length > 0 ? uniqueRealUsers : uniqueDummyUsers;

      // 생성 시간 순으로 정렬 (최신순)
      const sortedUsers = usersToShow.sort((a, b) => {
        const aTime = a.createdAt instanceof Date ? a.createdAt.getTime() : a.createdAt.toDate().getTime();
        const bTime = b.createdAt instanceof Date ? b.createdAt.getTime() : b.createdAt.toDate().getTime();
        return bTime - aTime;
      });
      
      setUsers(sortedUsers);
      
    } catch (error) {
      console.error('유저 데이터 가져오기 오류:', error);
      setUsers([]);
    }
  };

  // 이미지 비율 계산 및 폰트 로딩 확인
  useEffect(() => {
    calculateImageAspectRatio();
    calculateSendMessageAspectRatio();
    checkFontLoaded();
  }, []);

  useEffect(() => {
    // 로컬 스토리지에서 currentUser 확인
    const currentUser = localStorage.getItem('currentUser');
    
    if (!currentUser) {
      setIsValid(false);
      return;
    }

    try {
      const userData = JSON.parse(currentUser);

      if (!userData.createdAt) {
        setIsValid(false);
        return;
      }

      // createdAt 시간과 현재 시간 비교
      const createdAt = new Date(userData.createdAt);
      const currentTime = new Date();
      const timeDifference = currentTime.getTime() - createdAt.getTime();
      const hoursDifference = timeDifference / (1000 * 60 * 60); // 시간 단위로 변환


      // 2시간 이내인지 확인
      if (hoursDifference <= 2) {
        setIsValid(true);
        
        // 현재 사용자 닉네임 설정
        setCurrentUserNickname(userData.nickname || '');
        
        // 파이어베이스에서 최신 사용자 정보 가져와서 업데이트
        if (userData.nickname && userData.avatarNumber) {
          fetchCurrentUserFromFirebase(userData.nickname, userData.avatarNumber)
            .then((updatedUserData) => {
              if (updatedUserData) {
                // 업데이트된 코인 정보 설정
                setCoinCount(updatedUserData.coinCount || 0);
              } else {
                // 파이어베이스에서 가져오기 실패 시 기존 데이터 사용
                setCoinCount(userData.coinCount || 0);
              }
            })
            .catch((error) => {
              console.error('파이어베이스에서 사용자 정보 가져오기 실패:', error);
              setCoinCount(userData.coinCount || 0);
            });
        } else {
          // nickname이나 avatarNumber가 없는 경우 기존 데이터 사용
          setCoinCount(userData.coinCount || 0);
        }
        
        // 파이어베이스에서 유저 데이터 가져오기
        fetchRecentUsers();
      } else {
        setIsValid(false);
      }

    } catch (error) {
      console.error('사용자 데이터 파싱 오류:', error);
      setIsValid(false);
    }
  }, []);

  // 초기 스크롤 상태 설정
  useEffect(() => {
    if (scrollContentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollContentRef.current;
      setScrollTop(scrollTop);
      setScrollHeight(scrollHeight);
      setClientHeight(clientHeight);
    }
  }, [users]);

  const handleRefresh = () => {
    
    // 로딩 상태 시작
    setIsRefreshing(true);
    
    // 로컬 스토리지에서 현재 사용자 정보 가져오기
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      try {
        const userData = JSON.parse(currentUser);
        if (userData.nickname && userData.avatarNumber) {
          // 파이어베이스에서 최신 사용자 정보 가져와서 업데이트
          fetchCurrentUserFromFirebase(userData.nickname, userData.avatarNumber)
            .then((updatedUserData) => {
              if (updatedUserData) {
                // 업데이트된 코인 정보 설정
                setCoinCount(updatedUserData.coinCount || 0);
              }
            })
            .catch((error) => {
              console.error('새로고침 시 파이어베이스에서 사용자 정보 가져오기 실패:', error);
            });
        }
      } catch (error) {
        console.error('새로고침 시 사용자 데이터 파싱 오류:', error);
      }
    }
    
    // 파이어베이스에서 유저 데이터 다시 가져오기
    fetchRecentUsers();
    // 새로고침 시 선택 상태 초기화
    setSelectedUserId(null);
    
    // 1초 후 로딩 상태 종료
    setTimeout(() => {
      setIsRefreshing(false);
    }, 1000);
  };

  // 메시지 전송 모드로 전환할 때 메시지를 랜덤하게 섞기
  const handleChosenOk = () => {
    if (selectedUserId) {
      // 선택된 유저 정보 저장
      const selectedUserData = users.find(user => user.id === selectedUserId);
      setSelectedUser(selectedUserData || null);
      
      
      // 메시지를 랜덤하게 섞기
      setShuffledMessages(shuffleMessages(predefinedMessages));
      // 메시지 전송 모드로 전환
      setIsMessageSendMode(true);
    }
  };

  const handleBackButton = () => {
    // 메시지 전송 모드에서 선택 화면으로 돌아가기
    setIsMessageSendMode(false);
    setSelectedUser(null);
  };

  const handleMessageContainerClick = (userId: string) => {
    if (selectedUserId === userId) {
      // 같은 컨테이너를 다시 클릭하면 선택 해제
      setSelectedUserId(null);
    } else {
      // 다른 컨테이너를 클릭하면 선택 변경
      setSelectedUserId(userId);
    }
  };

  const handleMessageSendContainerClick = (messageIndex: number) => {
    // 기존 팝업이 열려있다면 먼저 닫기
    if (showMessageConfirmPopup) {
      setShowMessageConfirmPopup(false);
      setShowPopupElements(false);
      setIsPopupClosing(false);
      setSelectedMessageIndex(null);
    }
    
    // 새로운 팝업 열기
    setTimeout(() => {
      setSelectedMessageIndex(messageIndex);
      setShowMessageConfirmPopup(true);
      // 팝업 요소들을 2초 후에 페이드인
      setTimeout(() => {
        setShowPopupElements(true);
      }, 500);
    }, 100);
  };

  const handleScrollContentClick = (e: React.MouseEvent) => {
    // 클릭된 요소가 MessageContainer인지 확인
    const target = e.target as HTMLElement;
    const isMessageContainer = target.closest('[data-message-container]');
    
    // MessageContainer가 아닌 곳을 클릭했고, 현재 선택된 컨테이너가 있다면 선택 해제
    if (!isMessageContainer && selectedUserId) {
      setSelectedUserId(null);
    }
  };

  const handleScroll = () => {
    if (scrollContentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollContentRef.current;
      setScrollTop(scrollTop);
      setScrollHeight(scrollHeight);
      setClientHeight(clientHeight);
    }
  };

  const handleScrollTrackClick = (e: React.MouseEvent) => {
    if (scrollContentRef.current && scrollHeight > clientHeight) {
      const rect = e.currentTarget.getBoundingClientRect();
      const clickY = e.clientY - rect.top;
      const trackHeight = rect.height;
      const scrollRatio = clickY / trackHeight;
      const maxScrollTop = scrollHeight - clientHeight;
      const newScrollTop = scrollRatio * maxScrollTop;
      scrollContentRef.current.scrollTop = newScrollTop;
      setScrollTop(newScrollTop);
    }
  };

  // 스크롤바 썸의 위치와 높이 계산
  const getScrollThumbProps = () => {
    if (scrollHeight <= clientHeight) return { top: 0, height: 0 };
    const maxScrollTop = scrollHeight - clientHeight;
    const scrollRatio = scrollTop / maxScrollTop;
    const trackHeight = clientHeight - 10 * 2; // ScrollBar의 margin-top과 margin-bottom 제외
    const thumbHeight = Math.max(7 * 16, trackHeight * 0.2); // 최소 7dvw, 최대 trackHeight의 20%
    const top = scrollRatio * (trackHeight - thumbHeight);
    return { top, height: thumbHeight };
  };

  // 드래그 시작
  const handleThumbMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
    setDragStartY(e.clientY);
    setDragStartScrollTop(scrollTop);
  };

  // 드래그 중
  const handleMouseMove = (e: MouseEvent) => {
    if (!isDragging || !scrollContentRef.current) return;
    
    const deltaY = e.clientY - dragStartY;
    const trackHeight = clientHeight - 10 * 2; // ScrollBar의 margin-top과 margin-bottom 제외
    const maxScrollTop = scrollHeight - clientHeight;
    
    // 더 간단한 드래그 계산
    const scrollRatio = deltaY / trackHeight;
    const newScrollTop = Math.max(0, Math.min(maxScrollTop, dragStartScrollTop + (scrollRatio * maxScrollTop)));
    
    scrollContentRef.current.scrollTop = newScrollTop;
    setScrollTop(newScrollTop);
  };

  // 드래그 종료
  const handleMouseUp = () => {
    setIsDragging(false);
  };

  // 팁 버튼 클릭 핸들러
  const handleTipButtonClick = () => {
    setShowTipPopup(true);
  };

  // 팝업 클릭 핸들러
  const handlePopupClick = () => {
    setShowTipPopup(false);
  };

  // 메시지 확인 팝업 닫기
  const handleMessageConfirmPopupClose = () => {
    setIsPopupClosing(true);
    setShowPopupElements(false);
    setTimeout(() => {
      setShowMessageConfirmPopup(false);
      setIsPopupClosing(false);
      setSelectedMessageIndex(null);
    }, 800);
  };

  // 메시지 전송 확인
  const handleMessageConfirm = async () => {
    // 이미 메시지 전송 중이면 중복 실행 방지
    if (isSendingMessage) {
      return;
    }
    
    
    // 메시지 전송 시작
    setIsSendingMessage(true);
    
    try {
      // 보유 코인이 0~199개인지 확인 (200개 미만)
      if (coinCount < 200) {
        // 첫 번째 팝업과 요소들 페이드아웃
        setShowPopupElements(false);
        setIsPopupClosing(true);
        
        // 0.5초 후 첫 번째 팝업 닫고 코인 부족 팝업 열기
        setTimeout(() => {
          setShowMessageConfirmPopup(false);
          setIsPopupClosing(false);
          setShowCoinInsufficientPopup(true);
          
          // 코인 부족 팝업 요소들 페이드인
          setTimeout(() => {
            setShowCoinInsufficientElements(true);
          }, 200);
        }, 500);
        return;
      }
      
      // 코인 차감
      const deductSuccess = await deductCoins();
      if (!deductSuccess) {
        console.error('코인 차감 실패');
        return;
      }
      
      // 선택된 메시지와 수신자 정보
      const selectedMessage = shuffledMessages[selectedMessageIndex!];
      const receiverUser = selectedUser;
      
      if (receiverUser) {
        console.log('MessageSend: 메시지 전송 시작', { 
          receiverId: receiverUser.id,
          receiverNickname: receiverUser.nickname,
          message: selectedMessage,
          senderNickname: currentUserNickname 
        });
        
        // 수신자의 파이어베이스 데이터에 메시지 저장
        const saveMessageSuccess = await saveMessageToReceiver(receiverUser.id, selectedMessage, currentUserNickname);
        if (!saveMessageSuccess) {
          console.error('MessageSend: 메시지 저장 실패');
          return;
        }
        
        console.log('MessageSend: 메시지 저장 성공');
        
        // 메시지 전송 횟수 증가
        incrementMessageSendCount();
        
        // 현재 사용자 정보 가져오기
        const currentUser = localStorage.getItem('currentUser');
        if (currentUser) {
          const userData = JSON.parse(currentUser);
          // 발신자의 파이어베이스 데이터에 보낸 메시지 저장
          const saveSentMessageSuccess = await saveSentMessageToSender(
            selectedMessage, 
            receiverUser.nickname, 
            currentUserNickname, 
            userData.avatarNumber
          );
          if (!saveSentMessageSuccess) {
            console.error('보낸 메시지 저장 실패');
          }
        }
      }
      
      
      // 메시지 전송 시간을 localStorage에 저장 (주기적 팝업 쿨다운용)
      const messageSentTime = new Date();
      localStorage.setItem('messageSentTime', messageSentTime.getTime().toString());
      
      // 체험 시간 계산 및 저장
      const avatarRegistrationData = getAvatarRegistrationTime();
      if (avatarRegistrationData) {
        try {
          await saveExperienceTimeData(
            avatarRegistrationData.registrationTime,
            messageSentTime
          );
          
          // 메시지 전송한 유저 수 증가 (체험 중단 포인트 추적)
          incrementMessageSentUsers();
        } catch (error) {
          console.error('체험 시간 데이터 저장 실패:', error);
        }
      } else {
        console.log('화신 등록 시간 데이터를 찾을 수 없습니다.');
      }
      
      // 첫 번째 팝업과 요소들 페이드아웃
      setShowPopupElements(false);
      setIsPopupClosing(true);
      
      // 0.5초 후 첫 번째 팝업 닫고 두 번째 팝업 열기
      setTimeout(() => {
        setShowMessageConfirmPopup(false);
        setIsPopupClosing(false);
        setShowSecondPopup(true);
        
        // 두 번째 팝업 요소들 페이드인
        setTimeout(() => {
          setShowSecondPopupElements(true);
        }, 200);
      }, 500);
    } catch (error) {
      console.error('메시지 전송 중 오류 발생:', error);
    } finally {
      // 메시지 전송 완료 후 상태 초기화
      setIsSendingMessage(false);
    }
  };

    // 수신자의 파이어베이스 데이터에 메시지 저장
  const saveMessageToReceiver = async (receiverId: string, message: string, senderNickname: string) => {
    try {
      console.log('MessageSend: 메시지 저장 시작', { receiverId, message, senderNickname });
      
      // receiverId는 users_YYYYMMDD_HH_docId 형태이므로 파싱 필요
      // users_20250903_15_6kufLcKydR1TiYNApByM 형태
      const parts = receiverId.split('_');
      if (parts.length < 4) {
        console.error('MessageSend: 잘못된 receiverId 형식:', receiverId);
        return false;
      }
      
      // users_20250903_15_6kufLcKydR1TiYNApByM
      // [0] = users, [1] = 20250903, [2] = 15, [3] = 6kufLcKydR1TiYNApByM
      const collectionName = `${parts[0]}_${parts[1]}_${parts[2]}`; // users_20250903_15
      const docId = parts[3]; // 6kufLcKydR1TiYNApByM
      
      console.log('MessageSend: 파싱된 정보', { collectionName, docId });
      
      const userDocRef = doc(db, collectionName, docId);
      const userDoc = await getDoc(userDocRef);
      
      if (userDoc.exists()) {
        const userData = userDoc.data() as FirebaseUserData;
        console.log('MessageSend: 수신자 문서 발견', { 
          nickname: userData.nickname,
          currentReceivedMessages: userData.receivedMessages?.length || 0 
        });
        
        const newMessage = {
          message: message,
          senderNickname: senderNickname,
          receivedAt: Timestamp.now()
        };
        
        // 기존 receivedMessages 배열이 있으면 추가, 없으면 새로 생성
        const updatedMessages = userData.receivedMessages 
          ? [...userData.receivedMessages, newMessage]
          : [newMessage];
        
        console.log('MessageSend: 메시지 배열 업데이트', { 
          oldCount: userData.receivedMessages?.length || 0,
          newCount: updatedMessages.length 
        });
        
          await updateDoc(userDocRef, {
            receivedMessages: updatedMessages
          });
          
          console.log('MessageSend: 메시지 저장 완료', {
            receiverId,
            collectionName,
            docId,
            newMessageCount: updatedMessages.length,
            newMessage: {
              message: message,
              senderNickname: senderNickname,
              receivedAt: newMessage.receivedAt.toMillis()
            }
          });
          
          // 메시지 저장 후 잠시 대기 (Firebase 동기화 시간)
          await new Promise(resolve => setTimeout(resolve, 100));
          
          return true;
      } else {
        console.error('MessageSend: 수신자 문서를 찾을 수 없습니다:', receiverId);
        return false;
      }
    } catch (error) {
      console.error('MessageSend: 메시지 저장 오류:', error);
      return false;
    }
  };

  // 발신자의 파이어베이스 데이터에 보낸 메시지 저장
  const saveSentMessageToSender = async (message: string, receiverNickname: string, senderNickname: string, senderAvatarNumber: string) => {
    try {
      
      // 새로운 시간 기반 컬렉션 구조를 사용하여 발신자 정보 가져오기
      const senderData = await findValidUser(senderNickname, senderAvatarNumber);
      
      if (senderData) {
        const newSentMessage = {
          message: message,
          receiverNickname: receiverNickname,
          sentAt: Timestamp.now()
        };
        
        // sentMessages 필드가 없으면 빈 배열로 초기화
        if (!senderData.sentMessages) {
          await addSentMessagesFieldToUser(senderNickname, senderAvatarNumber);
        }
        
        // 기존 sentMessages 배열이 있으면 추가, 없으면 새로 생성
        const updatedSentMessages = senderData.sentMessages 
          ? [...senderData.sentMessages, newSentMessage]
          : [newSentMessage];
        
        // 새로운 시간 기반 컬렉션 구조를 사용하여 업데이트
        await updateUserInTimeBasedCollection(
          senderNickname,
          senderAvatarNumber,
          { sentMessages: updatedSentMessages }
        );
        
        // CollectionSentMessages에도 동일한 메시지 저장 (중복 방지 로직 포함)
        const userInfo = await getUserFromTimeBasedCollection(senderNickname, senderAvatarNumber);
        if (userInfo) {
          const { collectionName } = userInfo;
          await saveMessageToCollectionSentMessages(
            collectionName,
            message,
            receiverNickname,
            senderNickname,
            senderAvatarNumber
          );
        }
        
        return true;
      } else {
        console.error('발신자 문서를 찾을 수 없습니다:', senderNickname);
        return false;
      }
    } catch (error) {
      console.error('보낸 메시지 저장 오류:', error);
      return false;
    }
  };

  // 파이어베이스에서 코인 차감
  const deductCoins = async () => {
    try {
      const currentUser = localStorage.getItem('currentUser');
      if (!currentUser) return false;
      
      const userData = JSON.parse(currentUser);
      if (!userData.nickname || !userData.avatarNumber) return false;
      
      const currentCoins = userData.coinCount || 0;
      const newCoins = Math.max(0, currentCoins - 200);
      
      // 새로운 시간 기반 컬렉션 구조를 사용하여 코인 업데이트
      await updateUserInTimeBasedCollection(
        userData.nickname,
        userData.avatarNumber,
        { coinCount: newCoins }
      );
      
      // 로컬 스토리지 업데이트
      const updatedUserData = { ...userData, coinCount: newCoins };
      localStorage.setItem('currentUser', JSON.stringify(updatedUserData));
      setCoinCount(newCoins);
      
      return true;
    } catch (error) {
      console.error('코인 차감 오류:', error);
      return false;
    }
  };

  // 두 번째 팝업에서 다음 버튼 클릭
  const handleSecondPopupNext = () => {
    setShowSecondPopupElements(false);
    setTimeout(() => {
      setShowSecondPopup(false);
      
      // 코인 차감 후 남은 코인 계산 (coinCount는 이미 차감된 값)
      const remainingCoins = coinCount;
      
      // 코인이 0~199개이면 엔딩 페이지로 이동 (200개 미만)
      if (remainingCoins < 200) {
        setTimeout(() => {
          navigate('/ending');
        }, 2000);
      } else {
        // 코인이 200개 이상이면 세 번째 팝업 열기
        setShowThirdPopup(true);
        
        // 세 번째 팝업 요소들 페이드인
        setTimeout(() => {
          setShowThirdPopupElements(true);
        }, 200);
      }
    }, 500);
  };

  // 세 번째 팝업 닫기
  const handleThirdPopupClose = () => {
    setShowThirdPopupElements(false);
    setTimeout(() => {
      setShowThirdPopup(false);
      setSelectedMessageIndex(null);
    }, 500);
  };

  // 전역 마우스 이벤트 리스너 추가/제거
  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.body.style.userSelect = 'none';
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.userSelect = '';
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      document.body.style.userSelect = '';
    };
  }, [isDragging, dragStartY, dragStartScrollTop, scrollHeight, clientHeight]);

  if (isValid === null) {
    return (
      <Container>
        <TitleImage src={titleImage} alt="메시지 타이틀" />
        <Title>로딩 중...</Title>
      </Container>
    );
  }

  if (!isValid) {
    return (
      <Container>
        <TitleImage src={titleImage} alt="메시지 타이틀" />
        <Title>이용시간이 지나 사용할 수 없습니다</Title>
      </Container>
    );
  }

  // 메시지 전송 모드
  if (isMessageSendMode) {
    return (
      <Container>
        <Bookmark visible={1} />
        <BackButton onClick={handleBackButton}>
          <BackButtonImage src={backButtonImage} alt="뒤로가기" />
        </BackButton>
        
        <div style={{ 
          width: '100%', 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          flexShrink: 0,
          paddingTop: '2dvh'
        }}>
          <TitleImage src={titleImage} alt="메시지 타이틀" />
          <ChooseTextImage src={chooseTextImage} alt="메시지 선택 텍스트" />
        </div>
        
        <ScrollContainer>
          <ScrollContent 
            ref={scrollContentRef}
            onScroll={handleScroll}
            style={{ 
              gridTemplateColumns: '1fr',
              overflowX: 'hidden',
              touchAction: 'pan-y'
            }}
          >
            {shuffledMessages.length > 0 ? (
              shuffledMessages.map((message, index) => (
                <MessageSendContainer 
                  key={index} 
                  aspectRatio={sendMessageAspectRatio}
                  isFontLoaded={isFontLoaded}
                  onClick={() => handleMessageSendContainerClick(index)}
                >
                  <MessageSendContainerImage 
                    src={sendMessageContainerImage} 
                    alt="메시지 전송 컨테이너" 
                  />
                  <MessageSendContent>
                    <MessageText 
                      aspectRatio={sendMessageAspectRatio} 
                      textLength={message.length}
                    >
                      {message}
                    </MessageText>
                  </MessageSendContent>
                </MessageSendContainer>
              ))
            ) : (
              <div style={{
                width: '100%',
                padding: '2rem',
                textAlign: 'center',
                color: 'white',
                fontSize: '1.2rem'
              }}>
                메시지를 추가해주세요.
              </div>
            )}
          </ScrollContent>
          
          <ScrollBar>
            
            <ScrollTrack onClick={handleScrollTrackClick}>
              {(() => {
                const { top, height } = getScrollThumbProps();
                return height > 0 ? (
                  <ScrollThumb 
                    top={top}
                    height={height}
                    onMouseDown={handleThumbMouseDown}
                    onDragStart={(e) => e.preventDefault()}
                  >
                    <ScrollThumbImage 
                      src={scrollHeaderImage} 
                      alt="스크롤 헤더"
                      draggable={false}
                    />
                  </ScrollThumb>
                ) : null;
              })()}
            </ScrollTrack>
          </ScrollBar>
        </ScrollContainer>

        {/* 메시지 확인 팝업 */}
        {showMessageConfirmPopup && selectedMessageIndex !== null && selectedUser && (
          <PopupOverlay>
            {/* 팝업 위쪽 아바타 */}
            <div style={{ 
              position: 'absolute', 
              top: 'calc(40% - 25dvw)', 
              left: '50%', 
              transform: 'translateX(-50%)', 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              opacity: showPopupElements ? 1 : 0,
              transition: 'opacity 0.5s ease'
            }}>
              <AvatarContainer>
                <AvatarImage src={receivedAvatarImage} alt="받는 사람 아바타" />
                <AvatarNickname>
                  {selectedUser.nickname}
                </AvatarNickname>
              </AvatarContainer>
            </div>

            <BluePopup 
              isClosing={isPopupClosing}
              onClose={handleMessageConfirmPopupClose}
            >
              <div style={{ fontSize: '5.5dvw' }}>
                <div>
                  [성좌, '{currentUserNickname}'이(가)<br />
                  {shuffledMessages[selectedMessageIndex]?.replace(/^"|"$/g, '')}]
                </div>
              </div>
            </BluePopup>
            
            {/* 팝업 아래 텍스트와 버튼들 */}
            <div style={{ 
              position: 'absolute', 
              top: 'calc(55% + 22dvw)', 
              left: '50%', 
              transform: 'translateX(-50%)', 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              gap: '1rem',
              opacity: showPopupElements ? 1 : 0,
              transition: 'opacity 0.5s ease'
            }}>
              <PopupConfirmText>
                {isSendingMessage ? '메시지 전송 중...' : `'${selectedUser.nickname}'에게 보내시겠습니까?`}
              </PopupConfirmText>
              {isSendingMessage ? (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: '1rem'
                }}>
                  <img 
                    src={loadingImage} 
                    alt="전송 중" 
                    style={{
                      width: '30dvw',
                      height: 'auto'
                    }}
                  />
                </div>
              ) : (
                <div style={{ display: 'flex', gap: '0.5dvw', justifyContent: 'center' }}>
                  <PopupButton 
                    onClick={handleMessageConfirmPopupClose}
                    disabled={isSendingMessage}
                    style={{ 
                      opacity: isSendingMessage ? 0.5 : 1,
                      cursor: isSendingMessage ? 'not-allowed' : 'pointer'
                    }}
                  >
                    <PopupButtonImage src={cancelButtonImage} alt="취소" />
                  </PopupButton>
                  <PopupButton 
                    onClick={handleMessageConfirm}
                    disabled={isSendingMessage}
                    style={{ 
                      opacity: isSendingMessage ? 0.5 : 1,
                      cursor: isSendingMessage ? 'not-allowed' : 'pointer'
                    }}
                  >
                    <PopupButtonImage src={okButtonImage} alt="확인" />
                  </PopupButton>
                </div>
              )}
            </div>
          </PopupOverlay>
        )}

        {/* 두 번째 팝업 - 바라보기 메시지 */}
        {showSecondPopup && selectedUser && (
          <PopupOverlay>
            <BluePopup 
              isClosing={false}
              onClose={() => {}}
            >
              <div style={{ fontSize: '4.6dvw' }}>
                <div>
         메시지 발송이 완료되었습니다.
                </div>
              </div>
            </BluePopup>
            
            {/* 두 번째 팝업 아래 버튼 */}
            <div style={{ 
              position: 'absolute', 
              top: 'calc(55% + 22dvw)', 
              left: '50%', 
              transform: 'translateX(-50%)', 
              display: 'flex', 
              justifyContent: 'center',
              opacity: showSecondPopupElements ? 1 : 0,
              transition: 'opacity 0.5s ease'
            }}>
              <SecondPopupButton onClick={handleSecondPopupNext}>
                <SecondPopupButtonImage src={secondPopupButtonImage} alt="다음" />
              </SecondPopupButton>
            </div>
          </PopupOverlay>
        )}

        {/* 세 번째 팝업 - another 이미지 */}
        {showThirdPopup && selectedUser && (
          <PopupOverlay>
            <div style={{ 
              width: '80%', 
              height: 'auto',
              opacity: showThirdPopupElements ? 1 : 0,
              transition: 'opacity 0.5s ease'
            }}>
              <img 
                src={anotherImage} 
                alt="another" 
                style={{ width: '100%', height: 'auto' }}
              />
            </div>
            
            {/* 세 번째 팝업 아래 텍스트와 버튼들 */}
            <div style={{ 
              position: 'absolute', 
              top: 'calc(50% + 12dvh)', 
              left: '50%', 
              transform: 'translateX(-50%)', 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              gap: '1rem',
              opacity: showThirdPopupElements ? 1 : 0,
              transition: 'opacity 0.5s ease'
            }}>
              <div style={{ 
                color: 'white', 
                fontFamily: 'MapoDPP, sans-serif', 
                fontSize: '4.5dvw',
                textAlign: 'center',
                textShadow: '0 2px 4px rgba(0,0,0,0.7)'
              }}>
                현재 보유 코인 : <span style={{ color: '#FFD700' }}>{coinCount}개</span>
              </div>
              <div style={{ display: 'flex', gap: '4dvw', justifyContent: 'center' }}>
                <PopupButton onClick={() => navigate('/ending')}>
                  <PopupButtonImage src={cancelButtonImage} alt="취소" />
                </PopupButton>
                <PopupButton onClick={() => {
                  setShowThirdPopup(false);
                  setShowThirdPopupElements(false);
                  setIsMessageSendMode(false);
                  setSelectedUser(null);
                  setSelectedUserId(null);
                }}>
                  <PopupButtonImage src={okButtonImage} alt="확인" />
                </PopupButton>
              </div>
            </div>
          </PopupOverlay>
        )}

        {/* 코인 부족 팝업 */}
        {showCoinInsufficientPopup && (
          <PopupOverlay>
            <BluePopup 
              isClosing={false}
              onClose={() => {}}
            >
              <div style={{ fontSize: '4.6dvw' }}>
                <div>
                  보유코인이 200개 미만이라<br />
                  메시지를 보낼 수 없습니다.
                </div>
              </div>
            </BluePopup>
            
            {/* 코인 부족 팝업 아래 버튼 */}
            <div style={{ 
              position: 'absolute', 
              top: 'calc(55% + 22dvw)', 
              left: '50%', 
              transform: 'translateX(-50%)', 
              display: 'flex', 
              justifyContent: 'center',
              opacity: showCoinInsufficientElements ? 1 : 0,
              transition: 'opacity 0.5s ease'
            }}>
              <NextButton onClick={() => navigate('/ending')}>
                <NextButtonImage src={nextButtonImage} alt="다음" />
              </NextButton>
            </div>
          </PopupOverlay>
        )}
      </Container>
    );
  }

  // 기존 선택 화면
  return (
    <Container>
      <Bookmark visible={1} />
      <div style={{ 
          width: '100%', 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          flexShrink: 0,
          paddingTop: '2dvh'
        }}>
          <TitleImage src={titleImage} alt="메시지 타이틀" />
          <ChooseImage src={chooseImage} alt="선택 이미지" />
          
          <TopSection>
            <CoinContainer>
              <CoinImage src={coinContainerImage} alt="코인 컨테이너" />
              <CoinText>
                보유코인 :&nbsp;<CoinNumber>{coinCount}개</CoinNumber>
              </CoinText>
              <TipButton onClick={handleTipButtonClick}>
                <TipButtonImage src={questionImage} alt="팁" />
              </TipButton>
            </CoinContainer>
            
            <RefreshButton onClick={handleRefresh}>
              <RefreshImage src={refreshImage} alt="새로고침" />
            </RefreshButton>
          </TopSection>
        </div>
      
      <ScrollContainer>
        <ScrollContent 
          ref={scrollContentRef}
          onScroll={handleScroll}
          onClick={handleScrollContentClick}
          style={{
            overflowX: 'hidden',
            touchAction: 'pan-y'
          }}
        >
          {users.length > 0 ? (
            users.map((user) => (
              <MessageContainer 
                key={user.id} 
                aspectRatio={imageAspectRatio}
                isSelected={selectedUserId === user.id}
                isDisabled={selectedUserId !== null && selectedUserId !== user.id}
                isFontLoaded={isFontLoaded}
                onClick={() => handleMessageContainerClick(user.id)}
                data-message-container="true"
              >
                <MessageContainerImage 
                  src={selectedUserId === user.id ? messageContainerSelectedImage : messageContainerImage} 
                  alt="메시지 컨테이너" 
                />
                <MessageContent>
                  <NicknameText 
                    aspectRatio={imageAspectRatio} 
                    textLength={user.nickname.length}
                    isSelected={selectedUserId === user.id}
                  >
                    {user.nickname}
                  </NicknameText>
                  <BackgroundText 
                    aspectRatio={imageAspectRatio} 
                    textLength={user.background.length}
                    isSelected={selectedUserId === user.id}
                  >
                    {user.background}
                  </BackgroundText>
                </MessageContent>
              </MessageContainer>
            ))
          ) : (
            <div style={{
              width: '100%',
              padding: '2rem',
              textAlign: 'center',
              color: 'white',
              fontSize: '1.2rem'
            }}>
              아직 참여한 사용자가 없습니다.
            </div>
          )}
        </ScrollContent>
        
        <ScrollBar>
          
          <ScrollTrack onClick={handleScrollTrackClick}>
            {(() => {
              const { top, height } = getScrollThumbProps();
              return height > 0 ? (
                <ScrollThumb 
                  top={top}
                  height={height}
                  onMouseDown={handleThumbMouseDown}
                  onDragStart={(e) => e.preventDefault()}
                >
                  <ScrollThumbImage 
                    src={scrollHeaderImage} 
                    alt="스크롤 헤더"
                    draggable={false}
                  />
                </ScrollThumb>
              ) : null;
            })()}
          </ScrollTrack>
        </ScrollBar>
      </ScrollContainer>
      
      {/* 선택완료 버튼 */}
      <div style={{ 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'center',
        flexShrink: 0,
        paddingBottom: '2dvh'
      }}>
        <ChosenOkButton 
          onClick={handleChosenOk}
          isDisabled={!selectedUserId}
        >
          <ChosenOkImage src={chosenOkImage} alt="선택완료" />
        </ChosenOkButton>
      </div>
       
       {/* 팁 팝업 */}
       <TipPopup isVisible={showTipPopup} onClick={handlePopupClick}>
         <TipPopupImage src={tipPopupImage} alt="팁 팝업" />
       </TipPopup>
       
       {/* 로딩 오버레이 */}
       {isRefreshing && (
         <div style={{
           position: 'fixed',
           top: 0,
           left: 0,
           width: '100dvw',
           height: '100dvh',
           background: 'rgba(0, 0, 0, 0.7)',
           display: 'flex',
           alignItems: 'center',
           justifyContent: 'center',
           zIndex: 2000,
           pointerEvents: 'auto'
         }}>
           <img 
             src={loadingImage} 
             alt="로딩 중" 
             style={{
               width: '40dvw',
               height: 'auto',
               pointerEvents: 'none'
             }}
           />
         </div>
       )}
     </Container>
   );
 };

export default withUrlValidation(MessageSend, {
  requireValidation: false,
  showCountdown: false
});
